import { render, staticRenderFns } from "./product-select-modal.vue?vue&type=template&id=171dcfd8&scoped=true&"
import script from "./product-select-modal.vue?vue&type=script&lang=js&"
export * from "./product-select-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dcfd8",
  null
  
)

export default component.exports